import get from 'lodash/get';
export const getScope = (payload) => {
    return get(payload, 'scope');
};
export const getValue = (payload) => {
    return get(payload, 'value', payload);
}; // payload can be null
export const getScopeAndValue = (payload) => {
    const scope = getScope(payload);
    const value = getValue(payload);
    return {
        scope,
        value,
    };
};
